var React = require('react');

function ReadMoreArrow (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"news_arrow","transform":"translate(1 1.414)"},[React.createElement("path",{"id":"Path_148","data-name":"Path 148","d":"M1370,4190.176l6.713,6.713L1370,4203.6","transform":"translate(-1351.356 -4190.176)","fill":"none","stroke":"#a1daf8","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"2","key":0}),React.createElement("line",{"id":"Line_2","data-name":"Line 2","x1":"24","transform":"translate(0 6.713)","fill":"none","stroke":"#a1daf8","strokeLinecap":"round","strokeWidth":"2","key":1})]));
}

ReadMoreArrow.defaultProps = {"width":"27.356","height":"16.254","viewBox":"0 0 27.356 16.254"};

module.exports = ReadMoreArrow;

ReadMoreArrow.default = ReadMoreArrow;
